import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'

import { Form, Field } from 'react-final-form'
import { Layout, Container, Content, Footer, PageTitle } from 'src/components/Layout'
import { Input, Checkbox } from 'src/components/Form'
import { UploadList } from 'src/components/Upload'
import { isEmpty } from 'src/utils/helpers'
import intlMessages from './translations'
import intlMessagesClaims from '../translations'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessagesDrivers from 'src/modules/Claims/Drivers/translations'
import styles from './OtherVehicleAndDriver.module.less'

import withToast from 'src/components/Toast'
import { Box, Text } from '@chakra-ui/react'
import Button from 'src/components/Button/Button'

class OtherVehicleAndDriver extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidUpdate(prevProps) {
    const {
      intl,
      deleteOtherDriverLicenseResponse,
      clearOtherDriverLicenseFile,
      toast,
    } = this.props

    // If there was an error while deleting a file
    if (
      !isEmpty(deleteOtherDriverLicenseResponse) &&
      deleteOtherDriverLicenseResponse !== prevProps.deleteOtherDriverLicenseResponse
    ) {
      if (deleteOtherDriverLicenseResponse.success) {
        clearOtherDriverLicenseFile()
      } else {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            deleteOtherDriverLicenseResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  handleSubmit = values => {
    this.props.setVehicleAndDriver(values)
    this.props.history.push('/claims/form')
  }

  /**
   * Add uploaded file to redux state
   */
  fileAdded = response => {
    const {
      otherDriversLicenseFile,
      otherDriversLicenseRemove,
      otherDriversLicenseAdd,
    } = this.props

    // Delete current drivers license when adding new one
    if (
      otherDriversLicenseFile &&
      otherDriversLicenseFile.hasOwnProperty('url') &&
      otherDriversLicenseFile.url
    ) {
      otherDriversLicenseRemove(otherDriversLicenseFile)
    }

    if (response && response.file) {
      otherDriversLicenseAdd(response.file)
    }
  }

  /**
   * Delete file from Amazon S3 storage
   */
  fileDelete = file => {
    if (!file) {
      return false
    }

    // if(file && file.hasOwnProperty('url') && file.url && file.hasOwnProperty('stateId') && file.stateId) {
    if (file.hasOwnProperty('id') && file.id) {
      // Delete temporary file from state
      this.props.otherDriversLicenseRemove(file)
    }
  }

  render() {
    const { vehicleAndDriver, intl, otherDriversLicenseFile, isWidgetState } = this.props
    return (
      <Layout className='m-claims-other-vehicle-and-driver'>
        <Content>
          <PageTitle
            showBack={true}
            title={intl.formatMessage(intlMessages.otherVehicleHeadline)}
            subtitle={intl.formatMessage(intlMessagesClaims.claimsFillOutTheForm)}
          />
          <Container padder className='global-centered-desktop-content'>
            <Form
              onSubmit={this.handleSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Content>
                    <Text fontWeight={500} variant='secondary' fontSize={'16px'} align={'center'}>
                      <FormattedMessage
                        id='app.otherVehicle.subHeadline'
                        defaultMessage='Vehicle Info'
                      />
                    </Text>
                    <Field
                      name='make'
                      initialValue={vehicleAndDriver && vehicleAndDriver.make}
                      render={({ input, meta }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='make'
                            placeholder={intl.formatMessage(intlMessages.placeholderMake)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='model'
                      initialValue={vehicleAndDriver && vehicleAndDriver.model}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='model'
                            placeholder={intl.formatMessage(intlMessages.placeholderModel)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='color'
                      initialValue={vehicleAndDriver && vehicleAndDriver.color}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='color'
                            placeholder={intl.formatMessage(intlMessages.placeholderColor)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='year'
                      initialValue={vehicleAndDriver && vehicleAndDriver.year}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='year'
                            placeholder={intl.formatMessage(intlMessages.placeholderYear)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />

                    <Text
                      fontWeight={500}
                      variant='secondary'
                      mt={'30px'}
                      fontSize={'16px'}
                      align={'center'}
                    >
                      <FormattedMessage
                        id='app.document.addDriver.driverInfo'
                        defaultMessage='Driver Info'
                      />
                    </Text>
                    <Field
                      name='firstName'
                      initialValue={vehicleAndDriver && vehicleAndDriver.firstName}
                      render={({ input, meta }) => (
                        <Box mt={'15px'} mb={'10px'}>
                          <Input
                            name='firstName'
                            placeholder={intl.formatMessage(intlMessages.placeholderFirstName)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='lastName'
                      initialValue={vehicleAndDriver && vehicleAndDriver.lastName}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='lastName'
                            placeholder={intl.formatMessage(intlMessages.placeholderLastName)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='policy'
                      initialValue={vehicleAndDriver && vehicleAndDriver.policy}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='policy'
                            placeholder={intl.formatMessage(intlMessages.placeholderPolicy)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='insuranceCompany'
                      initialValue={vehicleAndDriver && vehicleAndDriver.insuranceCompany}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='insuranceCompany'
                            placeholder={intl.formatMessage(
                              intlMessages.placeholderInsuranceCompany,
                            )}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='licensePlate'
                      initialValue={vehicleAndDriver && vehicleAndDriver.licensePlate}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='licensePlate'
                            placeholder={intl.formatMessage(intlMessages.placeholderLicensePlate)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />
                    <Field
                      name='driverLicense'
                      initialValue={vehicleAndDriver && vehicleAndDriver.driverLicense}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='driverLicense'
                            placeholder={intl.formatMessage(intlMessages.placeholderDriverLicense)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />

                    <div className={styles.driverLicensePhotoUploader}>
                      <UploadList
                        isWidget={isWidgetState}
                        files={
                          otherDriversLicenseFile && otherDriversLicenseFile.hasOwnProperty('url')
                            ? [otherDriversLicenseFile]
                            : []
                        }
                        addText={intl.formatMessage(
                          intlMessagesDrivers.driversUploadDriversLicensePhoto,
                        )}
                        onFileAdded={this.fileAdded}
                        onFileDelete={this.fileDelete}
                        hideDropZoneWithFiles={true}
                        classNameFileHolder={styles.driverLicensePhotoFileHolder}
                        dropZoneOptions={{
                          onDropHandlerUrl: '/claims/driversLicensePhoto',
                          classNameHolder: styles.driverLicensePhotoDropZoneHolder,
                          multiple: false,
                          supportedUploadTypes: [
                            'image/jpeg',
                            'image/jpg',
                            'image/png',
                            'image/gif',
                            'image/svg',
                          ],
                        }}
                      />
                    </div>
                    <Field
                      name='phone'
                      initialValue={vehicleAndDriver && vehicleAndDriver.phone}
                      render={({ input, meta }) => (
                        <Box mb={'10px'}>
                          <Input
                            name='phone'
                            placeholder={intl.formatMessage(intlMessages.placeholderPhone)}
                            error={meta}
                            type='text'
                            {...input}
                          />
                        </Box>
                      )}
                    />

                    <div style={{ textAlign: 'center' }}>
                      <Field
                        name='owner'
                        initialValue={
                          vehicleAndDriver && vehicleAndDriver.hasOwnProperty('owner')
                            ? vehicleAndDriver.owner
                            : true
                        }
                        render={({ input, meta }) => (
                          <Box mb={'10px'}>
                            <Checkbox
                              error={meta}
                              name='owner'
                              label={
                                <FormattedMessage
                                  id='app.otherVehicle.ownerOfVehicleSwitch'
                                  defaultMessage='Is this the owner of the vehicle?'
                                />
                              }
                              {...input}
                            />
                          </Box>
                        )}
                      />
                    </div>
                  </Content>
                  <Footer>
                    <Button mt={'30px'} isFullWidth type='submit'>
                      <FormattedMessage id='app.otherVehicle.submit' defaultMessage='Submit' />
                    </Button>
                  </Footer>
                </form>
              )}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(withToast(OtherVehicleAndDriver))
